exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".absences-list-management-page {\n  padding: 1rem 0 60px;\n}\nh1 {\n  font-size: 32px;\n  font-weight: bold;\n  color: #0B486B;\n  margin-bottom: 1rem;\n}\n.header-bar {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 16px;\n  gap: 1rem;\n}\n.header-bar input {\n  max-width: 400px;\n  width: 100%;\n}", ""]);

// exports
